/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiEmptyPrompt, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

type Props = {
  isError: boolean
}

const messages = {
  'no-data-found': {
    id: 'billing.notifications.budgets.budget-settings.cost-trends.chart.no-data-found',
    defaultMessage: 'No data found',
  },
  error: {
    id: 'billing.notifications.budgets.budget-settings.cost-trends.chart.error',
    defaultMessage: 'We could not load your cost trends data',
  },
}

const NoDataAvailableFallback: FunctionComponent<Props> = ({ isError }) => (
  <EuiEmptyPrompt
    iconType='chartBarVertical'
    body={
      <EuiText size='s'>
        <FormattedMessage {...(isError ? messages.error : messages['no-data-found'])} />
      </EuiText>
    }
  />
)

export default NoDataAvailableFallback
